module.exports = __webpack_public_path__ + "img/features-translate.3cf36d79.svg";